const createTablePaginationOptions = (pageNumber, totalPages) => ({
  current: pageNumber,
  total: totalPages,
});

export { createTablePaginationOptions };
